import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'publicationDate'
})
export class PublicationYearPipe implements PipeTransform {

  transform(date: string): string {
    if (date && date.startsWith('DL')) {
      return date.substring(0, 7);
    }

    if (date && date.length === 8) {
      return date.substring(0, 4);
    }

    return date;
  }

}
